import React, { Component, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  PieChartOutlined,
  LogoutOutlined,
  AreaChartOutlined
} from "@ant-design/icons";
import "./index.css";
import { Layout, Menu, Button, message } from "antd";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  Link,
  useHistory,
} from "react-router-dom";

import { HomePage } from "../../components/homepage";
import { ClassManage } from "./components/classManage";
import { RecordProcessing } from "./components/recordProcessing";
import { PersonalInformation } from "../../components/personalInformation";
import { CheckResult } from "../../components/checkResult";


const { Header, Sider, Content } = Layout;

export const PreceptorHome = (params) => {
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory(); // 获取history对象
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  if (!userInfo) {
    message.error("请登录！！！");
    history.push("/");
  }
  console.log(userInfo);

  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
      onClick: () => handleMenuClick(key), // 添加点击事件
    };
  }

  // 菜单点击处理函数
  const handleMenuClick = (key) => {
    switch (key) {
      case "1":
        history.push("/preceptorhome/home"); // 导航到first页面
        break;
      case "2":
        history.push("/preceptorhome/classManage"); // 导航到second页面
        break;
      case "3":
        history.push("/preceptorhome/recordProcessing"); // 导航到third页面
        break;
      case "4":
        history.push("/preceptorhome/checkResult"); // 导航到third页面
        break;
      case "5":
        history.push("/preceptorhome/personalInformation"); // 导航到third页面
        break;
      default:
        break;
    }
  };

  const items = [
    getItem("首页", "1", <UserOutlined />),
    getItem("班级管理", "2", <PieChartOutlined />),
    getItem("申请记录处理", "3", <VideoCameraOutlined />),
    getItem("评价结果详情", "4", <AreaChartOutlined />),
    getItem("个人信息", "5", <UserOutlined />),
  ];

  return (
    <div className="Homediv">
      <Layout id="components-layout-demo-custom-trigger">
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <div className="logo" style={{ overflow: "hidden",borderRadius:"6px" }}>
            欢迎您{userInfo.role}:{userInfo.full_name}
          </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["1"]}
            items={items}
          />
        </Sider>
        <Layout className="site-layout">
          <Header
            className="site-layout-background"
            style={{
              padding: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: "trigger",
                onClick: () => setCollapsed(!collapsed),
              }
            )}
            <div
              className="logout"
              onClick={() => {
                history.push("/");
                localStorage.removeItem("userInfo");
              }}
            >
              <LogoutOutlined />
            </div>
          </Header>
          <Content
            className="site-layout-background"
            style={{
              margin: "24px 16px",
              padding: 24,
              minHeight: 280,
            }}
          >
            <Switch>
              <Route path="/preceptorhome/home" component={HomePage} />
              <Route
                path="/preceptorhome/classManage"
                render={() => <ClassManage userInfo={userInfo} />}
              />
              <Route
                path="/preceptorhome/recordProcessing"
                render={() => <RecordProcessing userInfo={userInfo} />}
              />
              <Route
                path="/preceptorhome/checkResult"
                render={() => <CheckResult userInfo={userInfo} />}
              />

              <Route
                path="/preceptorhome/personalInformation"
                render={() => <PersonalInformation userInfo={userInfo} />}
              />
              <Redirect from="/preceptorhome" to="/preceptorhome/home" />
              {/* 默认重定向到first页面 */}
            </Switch>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
};
